/* wsapi3-newsletter v1.0 */
/* Deploy Version 2026-09-19 14:16:24 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: 'newsletter',
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'create',
  create() {
    try {
      document.querySelectorAll('[data-wsjs-newsletter="container"]').forEach(newsForm => {
        newsForm.addEventListener('submit', (e) => { e.preventDefault(); wsMain.modules['newsletter'].registerNews(newsForm); });
      })

      // Pré-preenche o e-mail conhecido do visitante (login/identificação/contato anteriores)
      try {
        if (typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
          const known = ApiWS.CustomerEmail.get();
          if (known) {
            document.querySelectorAll('[data-wsjs-newsletter] input[type="email"]').forEach(inp => {
              if (!inp.value) inp.value = known;
            });
          }
        }
      } catch (_) {}

      document.querySelectorAll('[data-wsjs-newsletter] input').forEach(inpt => {
        inpt.addEventListener('invalid' ,(event) => {
          event.preventDefault();
          event.target.parentNode.setAttribute('data-wsjs-error', 'true');
        });
        inpt.addEventListener('keydown', (event) => {
          try {
            event.target.parentNode.removeAttribute('data-wsjs-error');
          } catch(_) {}
        });
      });
    } catch(_) {

    }
    return true;
  },
  async registerNews(form = false) {
      form = document.querySelector('[data-wsjs-newsletter]');
      let name = form.querySelector('input[type="text"]').value,
          email = form.querySelector('input[type="email"]').value;

      let data = await ApiWS.Calls.CadastraNews(name, email);

      try {
        if (data && data.status == '200' && typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
          ApiWS.CustomerEmail.set(email, { source: 'newsletter' });
        }
      } catch (_) {}

      wsMain.modules['newsletter'].notificationNews(data);
  },
  notificationNews(returnJson) {
      if (returnJson.status == '200') {
          document.querySelector('.newsletter-message').innerText = returnJson.mensagem;
          document.querySelector('.newsletter-message').classList.add('success');
      } else {
          document.querySelector('.newsletter-message').innerText = returnJson.mensagem;
          document.querySelector('.newsletter-message').classList.add('error');
      }

      setTimeout(() => {
          document.querySelector('.newsletter-message').style.opacity = '1';
          document.querySelector('.newsletter-message').style.marginBottom = '7rem';
      }, 100);

      setTimeout(() => {
          document.querySelector('.newsletter-message').style.opacity = '0';
          setTimeout(() => {
              document.querySelector('.newsletter-message').classList.remove('success');
              document.querySelector('.newsletter-message').classList.remove('error');
          }, 400);
      }, 800)
  }
});
